import React, { useContext } from 'react';
import { AuthContext } from '../../contex/AuthProvider';
import { format } from 'date-fns/esm';
import toast from 'react-hot-toast';


const BooksModal = ({ booking, setBooking, refetch }) => {
    const { nameTitle: bookName, resalePrice, image } = booking;
    const { user } = useContext(AuthContext);
    const handleBooking = event => {
        event.preventDefault();
        const form = event.target;
        const location = form.location.value;
        const name = form.name.value;
        const email = form.email.value;
        const phone = form.phone.value;

        const bookings = {
            booking_date: format(new Date(), "PP"),
            bookName: bookName,
            BuyerName: name,
            email,
            phone,
            resalePrice: booking.resalePrice,
            location,
            image: booking.image

        }
        console.log(booking);



        fetch('https://assignment-12-server-imraniium-su.vercel.app/bookings', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(bookings)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                if (data.acknowledged) {
                    console.log(booking._id)

                    fetch(`https://assignment-12-server-imraniium-su.vercel.app/confirmbooking/${booking._id}`, {
                        method: 'PUT',
                        headers: {
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({ isConfirm: true })
                    }).then(res => res.json())
                        .then(data => {
                            console.log(data);
                            setBooking(null);
                            toast.success('Booking confirmed');
                            refetch();
                        })
                }
                else {
                    toast.error(data.message);
                }
            })
    }
    return (
        <>
            <input type="checkbox" id="Booking-modal" className="modal-toggle" />
            <div className="modal">
                <div className="modal-box relative">
                    <label htmlFor="Booking-modal" className="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
                    <h3 className="text-lg font-bold">{bookName}</h3>
                    <form onSubmit={handleBooking} className='grid grid-cols-1 gap-3 mt-8'>

                        <input name='name' type="text" defaultValue={user?.displayName} disabled placeholder="Your name" className="input w-full input-bordered" />
                        <input name='email' type="text" defaultValue={user?.email} disabled placeholder="Email Address" className="input w-full input-bordered" />
                        <input name='location' type="text" placeholder="Meeting location" className="input w-full input-bordered" />
                        <input name='phone' type="text" placeholder="Phone Number" className="input w-full input-bordered" /> <br />
                        <input className='btn btn-accent w-full text-white' type="submit" value='Submit' />
                    </form>
                </div>
            </div>
        </>
    );
};

export default BooksModal;